<template>
    <div class="bg-white flex flex-col sm:flex-row justify-center">
        <div class="max-w-7xl flex-grow py-4 sm:py-8 px-4 sm:px-6 lg:px-8">
            <h1 class="text-3xl font-extrabold tracking-tight text-gray-900">{{ this.name }}</h1>
            <p class="hidden sm:block mt-4 max-w-xl text-sm text-gray-700" v-if="this.description">
                {{ this.description }}
            </p>
        </div>
        <div class="p-4 flex flex-col justify-center" v-if="this.searchable !== false">
            <text-input name="search" label="Quick Search" autofocus :placeholder="`Search ${this.searchPlaceholder ?? this.name.toLowerCase()}`" @input="this.handleSearch">
                <SearchIcon class="h-6 text-gray-500"/>
            </text-input>

            <div
                v-if="globalSearch"
                @click="openSearchDialog"
                class="block xl:hidden mt-2 py-2 cursor-pointer px-4 text-md font-thin rounded-md text-white bg-reethi-purple hover:bg-purple-800">
                Search / New Request
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from '@/Shared/TextInput';
import {
    SearchIcon
} from '@heroicons/vue/solid';

export default {
    props: {
        name: String,
        description: String,
        searchable: Boolean,
        globalSearch: Boolean,
        searchPlaceholder: String,
    },
    components: {
        TextInput,
        SearchIcon,
    },
    methods: {
        openSearchDialog() {
            this.$bus.$emit('openSearch')
        },
        handleSearch(event) {
            this.$emit('search', event.target.value)
        }
    }
}
</script>
